{
  "account_is_inactive": "Votre compte est inactif",
  "addons_email_marketing": "Email marketing",
  "addons_email_marketing_description": "Créez des newsletters, envoyez des campagnes ciblées et analysez les résultats. Organisez vos contacts en listes et segments. Augmentez votre liste d'abonnés avec des formulaires d'inscription et choisissez parmi des centaines de modèles responsives.",
  "addons_email_marketing_lower": "<p>Inscrivez-vous pour:</p><ul><li><strong>Créer</strong>, <strong>envoyer</strong> et <strong>analyser</strong> des campagnes ciblées</li><li>Organiser <strong>vos contacts en listes</strong> et <strong>segments spécifiques</strong></li><li>Augmenter votre liste d'abonnés en utilisant des <strong>formulaires d'inscription</strong>, <strong>pop-ups</strong> ou des <strong>formulaires inline</strong> sur votre site Web</li><li>Accéder à plus de <strong>700 modèles gratuits</strong>, prêts à l'emploi, <strong>organisés par catégorie</strong> et entièrement <strong>responsives</strong></li><li>Tout en conformité avec la loi <strong>CAN-SPAM</strong> et le <strong>RGPD</strong></li></ul><p><a href=\"https://emailchef.com/fr/fonctionnalites/\" target=\"_blank\">En savoir plus</a> sur notre service d’email marketing.</p>",
  "addons_email_marketing_tryitforfree": "Commencez Votre Essai Gratuit",
  "addons_email_marketing_upper": "<p>Créez des campagnes de marketing par e-mail avec un service de messagerie professionnel et facile à utiliser. <strong>Les serveurs TurboSMTP vous garantissent les meilleurs taux de livraison en conformité au RGPD</strong>.<p>",
  "addons_email_validator": "Validateur d’e-mail",
  "addons_email_validator_description": "Un fichier téléchargé doit contenir une seule adresse e-mail sur chaque ligne. Les formats de fichiers autorisés sont csv et txt. Ou sélectionnez un fichier à télécharger.",
  "addons_emailmarketing_title": "Email marketing",
  "addons_title": "Addons",
  "analytics_average_click": "Délai de clic moyen",
  "analytics_average_click_description": "Temps moyen écoulé entre l'ouverture et le clic",
  "analytics_average_first": " Délai moyen de première ouverture",
  "emailvalidator_validate_freecredits_used": "Les crédits gratuits suivants seront utilisés:",
  "analytics_average_first_description": "Délai moyen entre la livraison et l'ouverture",
  "analytics_average_opens": "Taux d'ouverture moyen des e-mails",
  "analytics_average_opens_description": "Nombre moyen de fois qu'un e-mail a été ouvert.",
  "analytics_chart_frequency_d": "Quotidiennement",
  "analytics_chart_frequency_h": "Chaque heure",
  "analytics_chart_frequency_m": "Mensuel",
  "analytics_chart_frequency_w": "Hebdomadaire",
  "analytics_charts": "Tableaux",
  "analytics_clicks_title": "Pas de clics",
  "analytics_date": "Date",
  "analytics_description_clicks_empty": "Aucune donnée de clics trouvée.",
  "analytics_description_empty": "Il n'existe aucune valeur sur la période sélectionnée.",
  "analytics_event_bounce": "Rejeté",
  "analytics_event_clicks": "Cliqué",
  "analytics_event_delivered": "Transféré",
  "analytics_event_drop": "Abandonné",
  "analytics_event_opens": "Ouvert",
  "analytics_event_queued": "En queue",
  "analytics_event_sent": "Transféré",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Désinscrit",
  "analytics_events": "Événements",
  "analytics_events_all": "Tout",
  "analytics_events_bounce": "Rejeté",
  "analytics_events_bounce_tooltip": "Le pourcentage et le nombre d'e-mails rejetés par les serveurs de vos destinataires.",
  "analytics_events_bounces": "Rejets",
  "analytics_events_clicks": "Cliqué",
  "analytics_events_clicks_tooltip": "Le pourcentage et le nombre de personnes qui ont cliqué sur au moins un lien dans votre message.",
  "analytics_events_delivered": "Transféré",
  "analytics_events_delivered_tooltip": "Le pourcentage et le nombre de messages envoyés livrés avec succès.",
  "analytics_events_drop": "Abandonné",
  "analytics_events_drop_tooltip": "Ces e-mails sont exclus car ils ont été précédemment désabonnés, rejetés ou signalés comme spam. Les e-mails rejetés se trouvent dans la section Suppresions.",
  "analytics_events_opens": "Ouvert",
  "analytics_events_opens_tooltip": "Le pourcentage et le nombre d'e-mails ouverts par vos destinataires.",
  "analytics_events_queued": "En attente",
  "analytics_events_queued_tooltip": "Le pourcentage du nombre total d'e-mails qui sont dans la file d'attente de livraison.",
  "analytics_events_sent": "Transféré",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "Le pourcentage de destinataires qui ont signalé votre message comme spam.",
  "analytics_events_unsubscribes": "Désabonnements",
  "analytics_events_unsubscribes_tooltip": "Le pourcentage de demandes de désabonnement résultant de messages livrés avec succès.",
  "analytics_file": "Nom du fichier",
  "analytics_filterby_domain": "Domaine",
  "analytics_filterby_recipient": "Destinataire",
  "analytics_filterby_sender": "Émetteur",
  "analytics_filterby_subject": "Objet",
  "analytics_numbers": "Nombres",
  "analytics_openclick": "Analyse des ouvertures/clics",
  "analytics_overview": "Vue d’ensemble",
  "analytics_percentage": "Pourcentage",
  "analytics_reason": "Raison",
  "analytics_recipient": "Destinataire",
  "analytics_sender": "Émetteur",
  "analytics_status": "État",
  "analytics_subject": "Objet",
  "analytics_temporary_error": "Une erreur temporaire s'est produite. Veuillez réessayer ultérieurement.",
  "analytics_title": "Analytics",
  "analytics_topforopens": "Top d'ouvertures",
  "analytics_total_emails": "E-mails téléchargés",
  "analytics_total_processed": "E-mails traités",
  "analytics_upload_date": "Date de téléchargement",
  "and": "et",
  "annually": "Annuel",
  "authentication_expired": "Votre session a expiré. Veuillez vous reconnecter.",
  "billing_changepassword_description": "Changez votre mot de passe dans cette section. Ce mot de passe est utilisé uniquement pour accéder au Dashboard.",
  "billing_changepassword_title": "Modifier le mot de passe",
  "billing_contact_were_not_found": "Le contact de facturation est introuvable.",
  "billing_contacts_address": "Adresse",
  "billing_contacts_address2": "Adresse 2",
  "billing_contacts_billing": "E-mails de facturation - Factures et rappels de facturation",
  "billing_contacts_button_add": "Ajouter",
  "billing_contacts_button_edit": "Éditer",
  "billing_contacts_city": "Ville",
  "billing_contacts_company": "Nom de l’entreprise",
  "billing_contacts_country": "Pays",
  "billing_contacts_domain_email": "Services",
  "billing_contacts_editcontact": "Éditer le Contact",
  "billing_contacts_email": "Adresse e-mail",
  "billing_contacts_empty": "Les e-mails seront envoyés à l'adresse de votre compte principal. Entrez plus d'adresses pour envoyer des communications à des destinataires supplémentaires.",
  "billing_contacts_firstname": "Prénom",
  "billing_contacts_general_email": "Général",
  "billing_contacts_invoice_email": "Factures",
  "billing_contacts_lastname": "Nom",
  "billing_contacts_marketing": "E-mails de service - avis de renouvellement, confirmations d'inscription, etc.",
  "billing_contacts_phone": "Numéro de téléphone",
  "billing_contacts_products": "E-mails de produit - Détails de la commande, e-mails de bienvenue, etc.",
  "billing_contacts_products_email": "Produits",
  "billing_contacts_slide_description": "Les e-mails seront envoyés à l'adresse de votre compte principal. Entrez plus d'adresses pour envoyer des communications à des destinataires supplémentaires.",
  "billing_contacts_slide_title": "Ajouter nouveau contact",
  "billing_contacts_stateregion": "Région/Département/Commune",
  "billing_contacts_subscriptions": "Inscriptions",
  "billing_contacts_support": "E-mails d'assistance - Autoriser cet utilisateur à ouvrir des tickets dans votre compte.",
  "billing_contacts_support_email": "Soutien",
  "billing_contacts_terms": "J'ai lu et j'accepte la « Politique de confidentialité » et les « Conditions Générales »",
  "billing_contacts_title": "Ajouter contacts",
  "billing_contacts_transactional": "E-mails généraux - Annonces générales et rappels de mot de passe",
  "billing_contacts_zip": "Code postal",
  "billing_details_contact_above": "Envoyer uniquement au contact par défaut",
  "billing_emails_sentdate": "Date d'envoi",
  "billing_emails_subject": "Objet",
  "billing_invoice_date": "Date d'envoi",
  "billing_invoice_duedate": "Date d'échéance",
  "billing_invoice_number": "Numéro",
  "billing_invoice_status": "État",
  "billing_invoice_status_cancelled": "Cancelled",
  "billing_invoice_status_paid": "Payé",
  "billing_invoice_status_refunded": "Remboursé",
  "billing_invoice_status_unpaid": "Impayé",
  "billing_invoice_total": "Total",
  "billing_product_payment_method_banktransfer": "Virement bancaire",
  "billing_product_paymentmethod_avangate": "Carte de crédit (2Paiement)",
  "billing_product_paymentmethod_stripe": "Carte de crédit (Stripe)",
  "button_add_contact": "Ajouter contact",
  "button_add_filter": "Ajouter filtre",
  "button_add_plan": "Commander un nouveau forfait",
  "button_add_sender": "Ajouter un expéditeur",
  "button_add_subaccount": "Ajouter sous-compte",
  "button_add_suppression": "Ajouter suppression",
  "button_add_template": "Ajouter modèle",
  "button_addbcc": "Ajouter CCI",
  "button_addfooter": "Ajouter pied de page",
  "button_advanced_search": "Recherche avancée",
  "button_apply": "Appliquer",
  "button_back": "Retour",
  "button_basic_search": "Recherche simple",
  "button_buycredits": "Acheter des Crédits",
  "button_cancel": "Annuler",
  "button_close": "Fermer",
  "button_contact_us": "Nous contacter",
  "button_copy": "Copier",
  "button_create": "Créer",
  "button_createalert": "Créer Alerte",
  "button_delete": "Supprimer",
  "button_delete_all": "Effacer tout",
  "button_delete_filtered": "Supprimer filtré",
  "button_delete_selected": "Supprimer la sélection ({n})",
  "button_edit": "Éditer",
  "button_export": "Exporter",
  "button_import": "Importer le fichier",
  "button_limits": "Établir limites",
  "button_more": "Plus",
  "button_next": "Suivant",
  "button_open_ticket": "Ouvrir un nouveau ticket",
  "button_pay": "Payer",
  "button_refresh": "Rafraîchir",
  "button_reload": "Rafraichir",
  "button_request_cancellation": "Demande d'annulation",
  "button_reset": "Réinitialiser",
  "button_returnlist": "Retour à la liste",
  "button_save": "Sauvegarder",
  "button_search": "Rechercher",
  "button_select_fromdevice": "Sélectionnez des fichiers sur votre appareil",
  "button_submit_ticket": "Envoyer ticket",
  "button_unsubscribe": "Ajouter lien de désinscription",
  "button_update": "Mettre à jour",
  "button_update_template": "Mettre à jour le modèle",
  "button_update_unsubscribe": "Mettre à jour le lien de désabonnement",
  "button_updatealert": "Mettre à jour l'Alerte",
  "button_updatebcc": "Mettre à jour la CCI",
  "button_updatefooter": "Mettre à jour le Pied de Page",
  "button_upgrade": "Mettre à jour",
  "button_upload": "Télécharger",
  "confirm_password_is_missing": "Confirmer mot de passe est obligatoire.",
  "dashboard_clicked": "Cliqué",
  "dashboard_delivered": "Transféré",
  "dashboard_emails_sent": "Nombre Total d'e-mails",
  "dashboard_emails_sent_out_of": "E-mails envoyés depuis",
  "dashboard_gotoanalytics": "Aller sur Analytics",
  "dashboard_new_version": "Une version mise à jour est disponible !",
  "dashboard_new_version_cancel": "OK",
  "dashboard_new_version_description": "Enregistrez d'abord votre travail, puis rechargez la page,<br> ou appuyez sur « Mettre à jour maintenant » pour charger une nouvelle version.",
  "dashboard_new_version_ok": "Mettre à jour maintenant",
  "dashboard_plan_emails": "e-mails",
  "dashboard_plan_label": "Forfait",
  "dashboard_plan_label_interval": "{interval} forfait",
  "dashboard_plan_limit_unit_daily": "jour",
  "dashboard_plan_limit_unit_monthly": "mois",
  "dashboard_plan_limit_unit_yearly": "année",
  "dashboard_recent_email_activities": "Activités de messagerie récentes",
  "dashboard_try": "Vous utilisez un « essai gratuit ». Pour afficher le tableau de bord complet :",
  "datepicker_last_3_months": "3 derniers mois",
  "datepicker_last_30days": "30 derniers jours",
  "datepicker_last_month": "Mois dernier",
  "datepicker_last_sevendays": "7 derniers jours",
  "datepicker_last_week": "Semaine dernière",
  "datepicker_last_year": "L'année dernière",
  "datepicker_this_month": "Ce mois-ci",
  "datepicker_this_year": "Cette année",
  "datepicker_today": "Aujourd'hui",
  "datepicker_yesterday": "Hier",
  "delete_all_bounce": "Supprimer tous les rejets",
  "delete_all_manual": "Supprimer tous les manuels",
  "delete_all_spam": "Supprimer tous les spams",
  "delete_all_unsubscribe": "Supprimer toutes les désinscriptions",
  "delete_fist_login_dont": "Ne plus afficher ce message.",
  "delete_fist_login_one": "<h3>Bienvenue dans le tableau de bord avancé turboSMTP.</h3><p>Consultez des statistiques en temps réel sur vos campagnes d'e-mailing<br> et améliorez vos résultats avec des outils professionnels.</p><h4>Veuillez suivre les instructions pour configurer votre panneau.</h4>",
  "delete_fist_login_three_a": "Veuillez saisir le nom du serveur SMTP dans votre logiciel de messagerie.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "N'oubliez pas de configurer les enregistrements DNS de votre domaine <br>Retrouvez les paramètres dans vos « Réglages ».",
  "delete_fist_login_two_a": "<h3>Ouvrir le suivi</h3><p>permet à turboSMTP de suivre les taux d'ouverture de vos messages.</p>",
  "delete_fist_login_two_b": "<h3>Suivi des clics</h3><p>permet à turboSMTP de suivre les taux de clics de vos messages.</p>",
  "editor_quill_button_title": "Afficher le texte source HTML",
  "editor_quill_cancel_text": "Annuler",
  "editor_quill_msg": "Éditer le contenu au format HTML",
  "editor_quill_ok_text": "Ok",
  "emails_month": "e-mails/mois",
  "emailvalidator_add_file": "Ajouter fichier",
  "emailvalidator_add_form_errors": "Erreurs formulaire",
  "emailvalidator_add_form_nofile_selected": "Aucun fichier n’a été sélectionné",
  "emailvalidator_add_value": "Vous pouvez ajouter entre",
  "emailvalidator_attention": "Attention !",
  "emailvalidator_available": "crédits gratuits",
  "emailvalidator_balance_description": "Votre solde créditeur est",
  "emailvalidator_balance_title": "Votre solde de validation",
  "emailvalidator_buy_extra_credit": "Acheter des crédits supplémentaires",
  "emailvalidator_complete": "Complété",
  "emailvalidator_confirm_delete_label": "Confirmer action",
  "emailvalidator_confirm_delete_text": "Souhaitez-vous réellement effacer cette liste ?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Contacter assistance <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "Le coût par e-mail est",
  "emailvalidator_date": "Date de création :",
  "emailvalidator_day": "Jour",
  "emailvalidator_details_empty": "aucun élément à l'intérieur",
  "emailvalidator_domain": "Domaine",
  "emailvalidator_domain_age": "Ancienneté du domaine.",
  "emailvalidator_email": "E-mail",
  "emailvalidator_email_addesses": "Adresses e-mail",
  "emailvalidator_empty": "Un fichier téléchargé doit contenir une seule adresse e-mail sur chaque ligne. Les formats de fichiers autorisés sont csv et txt. Ou sélectionnez un fichier à télécharger.",
  "emailvalidator_entry_details": "Détails de la validation",
  "emailvalidator_error": "Erreur",
  "emailvalidator_error_contact_support": "Erreur : contactez l'assistance !",
  "emailvalidator_expiring": "Expire le",
  "emailvalidator_export": "Exporter",
  "emailvalidator_free_email": "E-mail gratuit",
  "emailvalidator_how_many": "Combien d'e-mails souhaitez-vous valider ?",
  "emailvalidator_list_contains": "La liste téléchargée contient",
  "emailvalidator_list_not_removed": "Erreur lors de la suppression de la liste",
  "emailvalidator_list_removed": "La liste a été supprimée avec succès.",
  "emailvalidator_mx_record": "Enregistrement MX",
  "emailvalidator_please_enter_amout": "Veuillez saisir le montant que vous souhaitez ajouter à votre portefeuille virtuel.",
  "emailvalidator_price_calculator": "Calculateur de prix",
  "emailvalidator_price_email": "Prix par e-mail",
  "emailvalidator_process_now": "Procéder maintenant",
  "emailvalidator_refresh": "rafraîchir",
  "emailvalidator_slide_description": "Le fichier doit être une colonne contenant toutes les adresses e-mail que vous souhaitez importer.",
  "emailvalidator_slide_details_description": "Les formats de fichiers autorisés sont csv ou txt.",
  "emailvalidator_slide_details_title": "Glissez et déposez votre fichier ici",
  "emailvalidator_slide_manually_description": "Copiez et collez plusieurs adresses e-mail ou en masse dans la zone ci-dessous, séparées par une ligne de fin.",
  "emailvalidator_slide_manually_title": "Ajouter manuellement",
  "emailvalidator_smpt_provider": "Fournisseur SMTP",
  "emailvalidator_status": "État",
  "emailvalidator_status_abuse": "Abus",
  "emailvalidator_status_catch_all": "Divers",
  "emailvalidator_status_do_not_mail": "Ne pas envoyer d'e-mail",
  "emailvalidator_status_invalid": "Non valide",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Inconnu",
  "emailvalidator_status_valid": "Valide",
  "emailvalidator_title": "Validateur d’e-mail",
  "emailvalidator_total_cost": "Le coût total est",
  "emailvalidator_upload_warning": "Votre solde créditeur actuel est de {current_balance} Vous devez acheter {needed_balance} de crédit supplémentaire pour valider cette liste...",
  "emailvalidator_validate_list": "Valider liste",
  "emailvalidator_validate_now": "Valider maintenant",
  "emailvalidator_validated_lists": "Listes validées",
  "emailvalidator_validation_date": "Date de validation",
  "emailvalidator_value": "Valeur",
  "emailvalidator_you_have": "Vous disposez de",
  "empty_authorization_token": "Le jeton d'autorisation est manquant.",
  "empty_request_body": "La demande est incomplète",
  "error": "error",
  "file_too_large": "fichier_trop_lourd",
  "filter": "Filtre",
  "filter_by": "Filtrer par",
  "filter_fuzzy": "Recherche avancée",
  "filter_fuzzy_description": "Activez cette fonctionnalité pour renvoyer des éléments similaires au mot clé.",
  "filter_placeholder_analytics": "Recherche...",
  "filter_placeholder_suppressions": "Recherche...",
  "filter_suppressions_placeholder": "Effectuez une recherche par destinataire, expéditeur, objet de l'e-mail ou raison de la suppression.",
  "filters_show": "Afficher les filtres",
  "filters_hide": "Hide filters",
  "first_login_step": "Étape {n}",
  "forgot_password_changed": "Votre mot de passe a été modifié avec succès.",
  "forgot_password_click": "Cliquez ici",
  "forgot_password_confirm": "Confirmez votre mot de passe",
  "forgot_password_done": "Terminé !",
  "forgot_password_donot_match": "Les mots de passe ne correspondent pas.",
  "forgot_password_email_not_found": "Adresse e-mail introuvable",
  "forgot_password_enter_email": "Entrez votre adresse e-mail",
  "forgot_password_error": "Une erreur est survenue lors de la modification de votre mot de passe.",
  "forgot_password_expired": "L'e-mail pour réinitialiser votre mot de passe a expiré.",
  "forgot_password_pick": "Choisissez un mot de passe",
  "forgot_password_please_reset": "Veuillez définir votre mot de passe.",
  "forgot_password_recovery_email_sent": "L'e-mail de récupération a bien été envoyé",
  "forgot_password_resend": "pour renvoyer l'e-mail.",
  "forgot_password_reset": "Réinitialiser votre mot de passe",
  "forgot_password_send_password_reset_link": "Envoyer un lien de réinitialisation du mot de passe",
  "forgot_password_sent_email_to_update_password": "Nous venons de vous envoyer un e-mail contenant un lien pour mettre à jour votre mot de passe.",
  "forgot_password_set": "Définissez votre nouveau mot de passe",
  "forgot_password_should_have": "Le mot de passe doit contenir",
  "forgot_password_suggestions": "<li>Au moins une minuscule</li> <li>Au moins une majuscule</li><li>Au moins un numéro</li>10 caractères<li> minimum</li>",
  "forgot_password_switch": "Passer à la connexion",
  "forgot_password_switch_to_login": "Passer à la connexion",
  "forgot_password_token_is_missing": "Le jeton de mot de passe oublié est manquant",
  "forgot_password_unable_to_send": "E-mail impossible à envoyer.",
  "forgot_password_username": "Nom d'utilisateur e-mail",
  "forgot_password_we_will_send_you": "Nous vous enverrons un lien de récupération de mot de passe.",
  "free_account": "Compte gratuit",
  "friday": "Vendredi",
  "fuzzy_tooltip": "Activez cette fonctionnalité pour renvoyer des éléments similaires au mot clé",
  "goto_emailmarketing": "Aller à Email marketing",
  "goto_emailvalidator": "Aller à Validateur d’e-mail",
  "header_menu_support": "https://serversmtp.com/fr/services-clients-multilingue-24-7/",
  "internal_server_error_try_again": "Une erreur interne du serveur est survenue. Veuillez réessayer ultérieurement.",
  "invalid_authorization_token": "Jeton d’autorisation invalide.",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "La valeur limite doit être d'au moins 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "La valeur de la page doit être d'au moins 1",
  "invalid_value_for_orderby_parameter": "Le paramètre « trier par » n'est pas valide.",
  "invalid_value_for_the_parameter_type": "Valeur non valide pour le type de paramètre",
  "invoice_not_found": "Facture introuvable",
  "jwt_error_full_details": "Détails complets",
  "jwt_error_status": "Statut HTTP",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "L'URL suivante n'existe pas",
  "l_allrights": "Tous droits réservés",
  "l_antispam_policy": "Politique anti-spam",
  "l_copyright": "© turboSMTP 2010 - ",
  "l_dont_have_account": "Vous n'avez pas encore de compte ?",
  "l_email_address": "Adresse e-mail",
  "l_forgot_password": "Mot de passe oublié ?",
  "l_login": "Connexion",
  "l_password": "Mot de passe",
  "l_privacy_policy": "Politique de confidentialité",
  "l_remember_me": "Me laisser connecté.",
  "l_sign_up_here": "Inscrivez-vous ici",
  "l_tagline": "TurboSMTP - fournisseur de services SMTP professionnel",
  "l_username_email": "nom d'utilisateur e-mail",
  "l_welcome_back": "Bienvenu à nouveau",
  "language_changed_label": "Vous avez changé la langue",
  "language_changed_message": "Pour appliquer les changements de langue, rechargez la page",
  "language_changed_reload": "Recharger",
  "m_accountinfo": "Infos du compte",
  "m_analytics": "Analytique",
  "m_billing": "Factures pro-forma",
  "m_daily": "journalier",
  "m_dashboard": "Tableau de Bord",
  "m_emailsentout": "E-mails envoyés",
  "m_emailvalidator": "Validateur d’e-mail",
  "m_messages": "Messages du système",
  "m_monthly": "Mensuel",
  "m_myaccount": "Mon Compte",
  "m_mydetails": "Mon Compte",
  "m_noplans": "Aucun forfait",
  "m_of": "de",
  "m_products": "Mes produits",
  "m_savechanges": "Enregistrer les changements",
  "m_settings": "Réglages",
  "m_subaccounts": "Sous-comptes",
  "m_suppressions": "Suppressions",
  "m_tickets": "Mes tickets",
  "m_validuntil": "Valide jusqu'à",
  "m_yearly": "Annuelle",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Valeur manquante ou non valide fournie pour la variable WhiteLabeled",
  "missing_required_parameter": "Un paramètre nécessaire est manquant.",
  "missing_required_parameter_email": "L'E-mail est manquant",
  "missing_required_parameter_from": "L'adresse de l'expéditeur est manquante",
  "missing_required_parameter_to": "L'adresse du destinataire est manquant",
  "missing_required_parameter_tz": "L'élément « tz » est manquant.",
  "modal_confirmation": "Confirmation",
  "monday": "Lundi",
  "monthly": "Mensuel",
  "my_account_title": "Mon compte",
  "myaccount_2fa_title": "Authentification à deux facteurs",
  "myaccount_2fa_description": "Renforcez la sécurité de votre compte en activant l'authentification à deux facteurs (2FA). Cela ajoute une couche de protection supplémentaire à votre compte.",
  "myaccount_2fa_card_description": "Activez l'authentification à deux facteurs pour protéger votre compte.",
  "myaccount_2fa_select_method": "Sélectionner la méthode d'authentification",
  "myaccount_2fa_method": "Méthode d'authentification",
  "myaccount_2fa_method_placeholder": "Choisissez une méthode d'authentification",
  "myaccount_2fa_otp_description": "Utilisez une application d'authentification (comme Google Authenticator ou Authy) pour générer des codes temporels.",
  "myaccount_2fa_email_description": "Recevez des codes de vérification par e-mail.",
  "myaccount_2fa_sms_description": "Recevez des codes de vérification par SMS.",
  "myaccount_2fa_none_description": "Désactivez l'authentification à deux facteurs pour votre compte.",
  "myaccount_2fa_scan_qr": "Scanner le code QR",
  "myaccount_2fa_scan_qr_description": "Scannez ce code QR avec votre application d'authentification pour configurer l'authentification à deux facteurs.",
  "myaccount_2fa_manual_entry": "Ou saisissez ce code manuellement :",
  "myaccount_2fa_copy_secret": "Copier dans le presse-papiers",
  "myaccount_2fa_secret_copied": "Clé secrète copiée dans le presse-papiers",
  "myaccount_2fa_verify_code": "Vérifier le code",
  "myaccount_2fa_enter_code": "Saisir le code de vérification",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Saisissez le code à 6 chiffres de votre application d'authentification pour terminer la configuration.",
  "myaccount_2fa_method_updated": "Méthode d'authentification à deux facteurs mise à jour avec succès",
  "myaccount_2fa_otp_enabled": "Authentification à deux facteurs activée avec succès",
  "myaccount_2fa_current_status": "Statut actuel",
  "myaccount_2fa_status": "Statut de l'authentification à deux facteurs",
  "myaccount_2fa_status_disabled": "Désactivé",
  "myaccount_2fa_error_no_keycloak_id": "Impossible de configurer le 2FA : ID utilisateur introuvable",
  "myaccount_2fa_error_invalid_code": "Code de vérification invalide. Veuillez réessayer.",
  "myaccount_2fa_error_generic": "Une erreur s'est produite lors de la configuration de l'authentification à deux facteurs",
  "myaccount_2fa_enabled": "Activé",
  "myaccount_2fa_disabled_label": "Désactivé",
  "myaccount_2fa_disabled": "Authentification à deux facteurs désactivée avec succès",
  "myaccount_account_details": "Mon Compte",
  "myaccount_billing": "Factures pro-forma",
  "myaccount_billing_cancellation_contact_support": "Contacter le support",
  "myaccount_billing_cancellation_endofcycle_note": "Votre abonnement restera actif jusqu'à la fin de votre période de facturation en cours, après quoi il ne sera pas renouvelé.",
  "myaccount_billing_cancellation_proceed": "Poursuivre l'annulation",
  "myaccount_billing_cancellation_reason": "Raison pour l'annulation",
  "myaccount_billing_cancellation_select_reason": "Sélectionnez une raison",
  "myaccount_billing_cancellation_support_text": "Avant de partir, notre équipe support pourrait vous aider à résoudre votre problème sans annuler votre abonnement. Souhaitez-vous nous contacter d'abord ?",
  "myaccount_billing_contacts": "Gérez les contacts",
  "myaccount_billing_contacts_description": "Les e-mails seront envoyés à l'adresse de votre compte principal. Entrez plus d'adresses pour envoyer des communications à des destinataires supplémentaires.",
  "myaccount_billing_description": "Dans cette section, vous pouvez trouver les factures pro forma émises avant les factures fiscales.<br>Les factures fiscales vous seront envoyées par e-mail.",
  "myaccount_billing_details": "Compte et détails de facturation",
  "myaccount_billing_details_address": "Adresse",
  "myaccount_billing_details_address2": "Adresse 2",
  "myaccount_billing_details_billing_company_name": "Entreprise de facturation",
  "myaccount_billing_details_billing_contact": "Envoyer des factures pro forma à une adresse autre que l'adresse du compte",
  "myaccount_billing_details_billing_vat": "TVA / P.IVA / C.F.",
  "myaccount_billing_details_billing_website": "Site Web",
  "myaccount_billing_details_city": "Ville",
  "myaccount_billing_details_country": "Pays",
  "myaccount_billing_details_description": "Modifiez les détails de votre compte et votre adresse de facturation.",
  "myaccount_billing_details_details": "Détails de la facturation",
  "myaccount_billing_details_email": "Adresse e-mail",
  "myaccount_billing_details_fistname": "Prénom",
  "myaccount_billing_details_lastname": "Nom",
  "myaccount_billing_details_marketing": "Je souhaite recevoir des offres et des conseils dédiés de turboSMTP",
  "myaccount_billing_details_phone_number": "Numéro de téléphone",
  "myaccount_billing_details_policy": "J'ai lu et j'accepte la politique de confidentialité et les Conditions générales",
  "myaccount_billing_details_state": "Région/Département",
  "myaccount_billing_details_zip": "Code postal",
  "myaccount_billing_slides_description": "Vous trouverez ici les « factures pro forma » liées à votre compte.",
  "myaccount_billing_slides_nodata": "Aucune facture pro forma n'a été trouvée",
  "myaccount_billingcontacts_added": "Contact de facturation ajouté avec succès",
  "myaccount_billingcontacts_deleted": "Contact de facturation supprimé avec succès",
  "myaccount_billingcontacts_edited": "Contact de facturation édité avec succès",
  "myaccount_billingdetails_updated": "Les détails de facturation ont été mis à jour",
  "myaccount_change_password": "Modifier le mot de passe",
  "myaccount_confirm_delete_selectedcontact_label": "Confirmer action",
  "myaccount_confirm_delete_selectedcontact_text": "Voulez-vous vraiment supprimer ce contact ?",
  "myaccount_confirm_password": "Confirmer mot de passe",
  "myaccount_current_password": "Vérifier le mot de passe actuel",
  "myaccount_delimiter_change": "Modifier le délimiteur d'exportation CSV",
  "myaccount_delimiter_select": "Sélectionnez le délimiteur",
  "myaccount_language": "Langue d’affichage",
  "myaccount_language_change": "Changer de langue",
  "myaccount_language_description": "TurboSMTP est désormais disponible en anglais et en italien. (Le français, l'allemand, l'hébreu, le portugais, le russe, l'arabe et l'espagnol seront bientôt disponibles).",
  "myaccount_language_select": "Sélectionner la langue",
  "myaccount_localization": "Localisation",
  "myaccount_localization_description": "Modifier la langue ou le délimiteur d'exportation CSV.",
  "myaccount_messages": "Messages du système",
  "myaccount_messages_nomessages": "Aucun message reçu",
  "myaccount_messages_nomessages_description": "Dans cette section, vous trouverez les messages que notre système a envoyés à votre compte.",
  "myaccount_new_password": "Nouveau mot de passe",
  "myaccount_password_changed": "Le mot de passe a été modifié avec succès",
  "myaccount_password_choose": "Veuillez choisir un nouveau mot de passe",
  "myaccount_password_notmatch": "Ces mots de passe ne correspondent pas. Réessayez.",
  "myaccount_password_suggestions": "Les mots de passe doivent contenir au moins 10 caractères, y compris des lettres majuscules et minuscules et au moins un chiffre.",
  "myaccount_product_delete_label": "Confirmer action",
  "myaccount_product_delete_text": "Voulez-vous vraiment annuler ce produit?",
  "myaccount_product_deleted": "La demande d'annulation a été envoyée avec succès.",
  "myaccount_products": "Mes produits",
  "myaccount_products_billingcycle": "Cycle de facturation",
  "myaccount_products_cycle_annually": "Annuel",
  "myaccount_products_cycle_biennally": "Biennal",
  "myaccount_products_cycle_free_account": "Compte gratuit",
  "myaccount_products_cycle_month": "Mensuel",
  "myaccount_products_cycle_monthly": "Mensuel",
  "myaccount_products_cycle_one_time": "Une fois",
  "myaccount_products_cycle_onetime": "Une fois",
  "myaccount_products_cycle_quarterly": "Trimestriel",
  "myaccount_products_cycle_semi-annually": "Semestriel",
  "myaccount_products_cycle_triennially": "Triennal",
  "myaccount_products_cycle_year": "Annuel",
  "myaccount_products_cycle_yearly": "Annuel",
  "myaccount_products_fistpayment": "Montant du premier paiement",
  "myaccount_products_nextduedate": "Date du prochain paiement",
  "myaccount_products_noproduct": "Sans produits",
  "myaccount_products_noproduct_description": "Dans cette section, vous trouverez les produits et services associés au compte.",
  "myaccount_products_payment": "Méthode de paiement",
  "myaccount_products_price": "Prix",
  "myaccount_products_productservice": "Produit/Service",
  "myaccount_products_recurringamount": "Montant récurrent",
  "myaccount_products_registration": "Date d'inscription",
  "myaccount_products_slide_productservice_description": "Gérez votre produit directement depuis cet espace.",
  "myaccount_products_status": "État",
  "plans_addon_options_title": "Plans complémentaires",
  "plans_available_recurring_options_title": "Plans Disponibles",
  "plans_billing_cycle": "Cycle de facturation",
  "plans_current_plans_title": "Vos plans actuels",
  "plans_cycle_month": "Mensuel",
  "plans_cycle_monthly": "Mensuel",
  "plans_cycle_onetime": "Unique",
  "plans_cycle_year": "Annuel",
  "plans_cycle_yearly": "Annuel",
  "plans_downgrade_options_title": "Options de rétrogradation",
  "plans_feature_dedicated_ip": "IP dédiée",
  "plans_feature_email_credits": "Crédits email",
  "plans_feature_smtp_limit": "Limite SMTP",
  "plans_features": "Fonctionnalités",
  "plans_invoice_created": "La facture a été créée avec succès.",
  "plans_invoice_error": "Impossible de créer la facture. Veuillez réessayer.",
  "plans_load_error": "Impossible de charger les options du plan. Veuillez réessayer.",
  "plans_onetime_options_title": "Plans uniques",
  "plans_plan_name": "Nom du plan",
  "plans_plan_type": "Type de plan",
  "plans_select_plan": "Sélectionner le plan",
  "plans_type_addon": "Complément",
  "plans_type_onetime": "Unique",
  "plans_type_recurring": "Récurrent",
  "plans_upgrade_options_title": "Options de mise à niveau",
  "myaccount_sentdate": "Date d'envoi",
  "new_dashboard_error": "Désolé, une erreur est survenue :",
  "new_dashboard_if_you_think": "Si vous pensez voir ce message par erreur, veuillez <a href=\"https://serversmtp.com/fr/contacts/\" target=\"_blank\" >nous contacter</a>.",
  "new_dashboard_not_allowed": "Contactez notre<a href='https://serversmtp.com/fr/contacts/' target='_blank'> équipe d 'assistance</a> pour commencer à utiliser la version bêta du tableau de bord.",
  "new_dashboard_token_valid": "Le jeton n'est pas valide",
  "new_dashboard_token_wrong": "Le jeton est erroné",
  "new_dashboard_validating": "Validation du jeton...",
  "no": "Non",
  "no_parameters_was_provided_for_update": "Aucun paramètre n'a été fourni pour la mise à jour",
  "no_suppression_data_were_provided": "Aucune donnée de suppression n'a été fournie",
  "one_time": "Une fois",
  "optional": "Facultatif",
  "or": "ou",
  "password_is_invalid": "Aucun compte ne correspond à ce mot de passe",
  "password_is_missing": "Mot de passe manquant.",
  "password_length_should_not_be_less_than_10_characters": "Le mot de passe doit contenir au moins 10 caractères",
  "password_should_contain_at_least_one_uppercase_character": "Le mot de passe doit contenir au moins 1 caractère majuscule",
  "password_should_contain_at_least_one_lowercase_character": "Le mot de passe doit contenir au moins 1 caractère minuscule",
  "password_should_contain_at_least_one_digit": "Le mot de passe doit contenir au moins 1 chiffre",
  "password_should_equals_to_confirm_password": "La mot de passe et sa confirmation doivent correspondre",
  "plan": "plan",
  "plan_daily": "Forfait quotidien",
  "plan_monthly": "Forfait mensuel",
  "plan_short_daily": "jour",
  "plan_short_monthly": "mois",
  "plan_short_yearly": "an",
  "plan_yearly": "Forfait annuel",
  "primeng": {
    "accept": "Oui",
    "addRule": "Ajouter une règle",
    "after": "Après",
    "apply": "Appliquer",
    "before": "Avant",
    "cancel": "Annuler",
    "choose": "Choisir",
    "clear": "Dégager",
    "contains": "Contient",
    "dateAfter": "La date est postérieure",
    "dateBefore": "La date est antérieure",
    "dateFormat": "dd/mm/yy",
    "dateIs": "La date est",
    "dateIsNot": "La date n'est pas",
    "dayNames": [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi"
    ],
    "dayNamesMin": [
      "Di",
      "Lu",
      "Mar",
      "Mer",
      "Je",
      "Ve",
      "Sa"
    ],
    "dayNamesShort": [
      "Dim",
      "Lun",
      "Mar",
      "Mer",
      "Jeu",
      "Ven",
      "Sam"
    ],
    "emptyFilterMessage": "Aucun résultat trouvé",
    "emptyMessage": "Aucun résultat trouvé",
    "endsWith": "Se termine par",
    "equals": "Équivaut à",
    "firstDayOfWeek": 0,
    "gt": "Supérieur à",
    "gte": "Supérieur ou égal à",
    "is": "est",
    "isNot": "N'est pas",
    "lt": "Inférieur à",
    "lte": "Inférieur ou égal à",
    "max_limit_reached": "Vous avez atteint le nombre maximum de sous-comptes activables avec votre plan actuel.",
    "matchAll": "Faire correspondre tout",
    "matchAny": "Correspondre à n'importe quel",
    "medium": "Moyen",
    "monthNames": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    "monthNamesShort": [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jul",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc"
    ],
    "noFilter": "Aucun filtre",
    "notContains": "Ne contient pas",
    "notEquals": "Pas égal",
    "passwordPrompt": "Entrer un mot de passe",
    "reject": "Non",
    "removeRule": "Supprimer la règle",
    "startsWith": "Commence avec",
    "strong": "Forte",
    "today": "Aujourd'hui",
    "upload": "Télécharger",
    "weak": "Faible",
    "weekHeader": "Semaine"
  },
  "reject": "Non",
  "removeRule": "Supprimer la règle",
  "return_toaddons": "Retour à addons",
  "saturday": "Samedi",
  "server_error_please_try_again": "Erreur du serveur. Veuillez réessayer ultérieurement.",
  "server_error_while_performing_update": "Une erreur du serveur est survenue lors de la mise à jour",
  "server_problem_gateway_timeout": "Délai d'expiration de la passerelle du serveur, veuillez réessayer.",
  "server_problem_please_retry": "Problème de serveur, veuillez réessayer.",
  "server_problem_unknown_error": "Erreur du serveur inconnue, veuillez réessayer.",
  "settings_activities_description": "Recevez des rapports d'activité de compte dans votre boîte aux lettres. Les rapports peuvent être quotidiens, hebdomadaires et/ou mensuels et couvrir toutes les activités de votre compte.",
  "settings_activities_slide_dailyreport": "Rapport quotidien",
  "settings_activities_slide_day": "Jour",
  "settings_activities_slide_dayoftheweek": "Jour de la semaine",
  "settings_activities_slide_description": "Vous pouvez recevoir des rapports quotidiens, hebdomadaires et mensuels pour toutes les activités de votre compte. Votre rapport sera envoyé à votre adresse e-mail enregistrée.",
  "settings_activities_slide_monthlyreport": "Rapport mensuel",
  "settings_activities_slide_time": "Temps",
  "settings_activities_slide_title": "Rapports d’activité",
  "settings_activities_slide_weeklyreport": "Rapport hebdomadaire",
  "settings_activities_title": "Rapports d’activité",
  "settings_alert_usage_limit": "Limite d'utilisation",
  "settings_alerts_description": "Recevez une alerte par e-mail lorsque vous avez utilisé un pourcentage spécifique de vos crédits e-mail.",
  "settings_alerts_slide_add": "Ajouter une alerte",
  "settings_alerts_slide_description": "Pour éviter de manquer de relais au milieu d'un publipostage, recevez une alerte par e-mail lorsque vous atteignez un pourcentage défini de vos crédits. Nous vous suggérons d'activer l'alerte à 80% de votre crédit disponible.",
  "settings_alerts_slide_empty_description": "Définissez une alerte qui sera transférée à votre adresse e-mail lorsque vous atteignez un pourcentage défini de vos crédits.",
  "settings_alerts_slide_empty_title": "Ajouter une alerte",
  "settings_alerts_slide_frequency": "Fréquence",
  "settings_alerts_slide_percentage": "Pourcentage",
  "settings_alerts_slide_placeholder": "ex. nom@adresse.com",
  "settings_alerts_slide_sendto": "Envoyer à",
  "settings_alerts_slide_title": "Alertes",
  "settings_alerts_slide_type": "Type d'alerte",
  "settings_alerts_title": "Alertes",
  "settings_api_description": "Envoyez vos e-mails directement depuis votre site Web ou votre application avec l'API turboSMTP.",
  "settings_api_title": "Documentation de l’API",
  "settings_bccs_description": "Chaque adresse e-mail de la liste CCI recevra une copie de chaque e-mail sans que le destinataire ne voie les détails des autres destinataires.",
  "settings_bccs_enable": "Autoriser un compte de messagerie à recevoir une copie de tous les e-mails envoyés.",
  "settings_bccs_slide_add": "Ajouter CCI",
  "settings_bccs_slide_description": "Veuillez configurer et autoriser un ou plusieurs comptes de messagerie pour recevoir une copie de tous les e-mails.",
  "settings_bccs_slide_email": "E-mail",
  "settings_bccs_slide_empty": "Veuillez configurer un compte de messagerie et l'autoriser à recevoir une copie de tous les e-mails.",
  "settings_bccs_slide_empty_title": "Ajouter une adresse CCI",
  "settings_bccs_slide_name": "Nom",
  "settings_bccs_slide_not_verified": "Non vérifié",
  "settings_bccs_slide_status": "État",
  "settings_bccs_slide_title": "CCI (Copie carbone invisible)",
  "settings_bccs_slide_verified": "Vérifié",
  "settings_bccs_title": "CCI (Copie carbone invisible)",
  "settings_bounces_description": "L'activation des notifications de rejet nous envoie des notifications concernant vos e-mails rejetés. Pour recevoir vous-même toutes vos notifications de rejet, désactivez cette option.",
  "settings_bounces_title": "Gestion des rejets",
  "settings_click_tracking": "Suivi des clics",
  "settings_click_tracking_description": "Le suivi des clics enregistre tous les clics effectués sur chaque lien de vos e-mails.",
  "settings_dns_bar_description": "Les enregistrements SPF et DKIM doivent être ajoutés à tous les domaines d'adresse e-mail de l'expéditeur.",
  "settings_dns_bar_dkim_description": "Un enregistrement DKIM peut être ajouté en tant qu'enregistrement TXT en insérant ce qui suit :",
  "settings_dns_bar_dkim_title": "Enregistrements DKIM",
  "settings_dns_bar_domainaut": "Authentification de domaine",
  "settings_dns_bar_domainaut_description": "Autorisez TurboSMTP à envoyer des e-mails en votre nom.",
  "settings_dns_bar_domainaut_is": "Le mode 'Authentification de domaine' est:",
  "settings_dns_bar_spf_description": "Ajoutez l'enregistrement TXT suivant au domaine de l'adresse de l'enveloppe (example.com), dans l'un des deux cas suivants :",
  "settings_dns_bar_spf_description_a": "<strong>Si un enregistrement SPF existe déjà dans la configuration DNS de votre domaine</strong>, vous devrez le modifier. Ajoutez simplement",
  "settings_dns_bar_spf_description_b": "directement après le segment",
  "settings_dns_bar_spf_description_c": "N'oubliez pas de laisser un espace avant et après cet ajout pour maintenir une syntaxe correcte.",
  "settings_dns_bar_spf_description_d": "<strong>Si vous n'avez pas d'enregistrement SPF existant</strong>, procédez à en créer un en saisissant les informations nécessaires dans un nouvel enregistrement TXT au sein de la configuration DNS de votre domaine (il n'est pas nécessaire de spécifier un Domaine SPF à moins que cela ne soit requis) :",
  "settings_dns_bar_spf_title": "Enregistrement SPF",
  "settings_dns_bar_title": "Réglages DNS",
  "settings_dns_description": "Ajoutez nos enregistrements DNS à votre domaine pour signer vos emails avec DKIM et assurer une transférabilité optimale.",
  "settings_dns_title": "Enregistrements DNS",
  "settings_email_body_tip": "Veuillez spécifier <% body %> dans vos données.",
  "settings_email_elements": "Éléments d'e-mail",
  "settings_email_footers_added": "Pied de page ajouté avec succès",
  "settings_email_footers_confirm_delete_label": "Confirmer action",
  "settings_email_footers_confirm_delete_text": "Voulez-vous vraiment effacer ce pied de page ?",
  "settings_email_footers_default": "Réglages du pied de page mis à jour avec succès",
  "settings_email_footers_removed": "Pied de page supprimé avec succès",
  "settings_email_footers_updated": "Pied de page mis à jour avec succès",
  "settings_email_name_tip": "Veuillez indiquer un nom",
  "settings_email_templates_added": "Modèle ajouté avec succès",
  "settings_email_templates_confirm_delete_label": "Confirmer action",
  "settings_email_templates_confirm_delete_text": "Souhaitez-vous réellement supprimer ce modèle ?",
  "settings_email_templates_default": "Réglages des modèles mis à jour avec succès",
  "settings_email_templates_removed": "Modèle supprimé avec succès",
  "settings_email_templates_updated": "Modèle mis à jour avec succès",
  "settings_email_unsub_added": "Lien de désinscription ajouté avec succès",
  "settings_email_unsub_confirm_delete_label": "Confirmer action",
  "settings_email_unsub_confirm_delete_text": "Voulez-vous vraiment effacer ce lien de désinscription ?",
  "settings_email_unsub_removed": "Lien de désinscription effacé avec succès",
  "settings_email_unsub_updated": "Lien de désinscription mis à jour avec succès",
  "settings_footers_description": "Ajoutez un pied de page à vos e-mails.",
  "settings_footers_slide_add": "Ajouter pied de page",
  "settings_footers_slide_convert": "de HTML au texte",
  "settings_footers_slide_default": "Par défaut",
  "settings_footers_slide_description": "Cliquez sur « Ajouter pied de page » ou modifiez un pied de page existant, puis entrez le nom du pied de page et remplissez les champs en HTML ou en texte brut.",
  "settings_footers_slide_empty_description": "Cliquez sur « Ajouter pied de page » ou modifiez un pied de page existant, puis entrez le nom du pied de page et remplissez les champs en HTML ou en texte brut.",
  "settings_footers_slide_empty_title": "Aucun pied de page",
  "settings_footers_slide_htmltext": "Texte HTML",
  "settings_footers_slide_name": "Nom",
  "settings_footers_slide_plaintext": "Texte brut",
  "settings_footers_slide_title": "Pieds de page",
  "settings_footers_title": "Pieds de page",
  "settings_ga_bar_description": "Veuillez remplir les champs suivants, y compris le nom et la source des données de votre campagne, pour activer votre intégration de Google Analytics.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "Contenu de la campagne",
  "settings_ga_content_mandatory": "Le contenu de la campagne est obligatoire",
  "settings_ga_integrate": "Intégrez Google Analytics pour suivre vos taux de conversion et d'autres données",
  "settings_ga_medium": "Support de campagne",
  "settings_ga_medium_mandatory": "Le support de campagne est obligatoire",
  "settings_ga_name": "Nom de la campagne",
  "settings_ga_name_mandatory": "Le nom de la campagne est obligatoire",
  "settings_ga_parameters": "Paramètres",
  "settings_ga_parameters_description": "Veuillez remplir les champs suivants, y compris le nom et la source des données de votre campagne, pour activer votre intégration de Google Analytics.",
  "settings_ga_source": "Source de la campagne",
  "settings_ga_source_mandatory": "La source de la campagne est obligatoire",
  "settings_ga_term": "Durée de la campagne",
  "settings_ga_term_mandatory": "La durée de la campagne est obligatoire",
  "settings_google_analytics_description": "Google Analytics suit vos taux de conversion et d'autres données.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Intégrations",
  "settings_integrations_authentication_disabled": "Le mode 'Authentification de domaine' est: Désactivé",
  "settings_integrations_authentication_enabled": "Le mode 'Authentification de domaine' est: Activé",
  "settings_integrations_dkim_updated": "Réglages DKIM mis à jour avec succès",
  "settings_notification_alert_confirm_delete_label": "Confirmer action",
  "settings_notification_alert_confirm_delete_text": "Voulez-vous vraiment supprimer cette alerte ?",
  "settings_notification_bcc_confirm_delete_label": "Confirmer action",
  "settings_notification_bcc_confirm_delete_success": "La CCI {email} a été supprimée avec succès.",
  "settings_notification_bcc_confirm_delete_text": "Souhaitez-vous réellement supprimer cette CCI {email} ?",
  "settings_notification_smtp_auth": "Authentification SMTP",
  "settings_notifications": "Notifications",
  "settings_notifications_alert_added": "L'alerte a été créée avec succès",
  "settings_notifications_alert_deleted": "L'alerte a été supprimée avec succès.",
  "settings_notifications_alert_updated": "L'alerte a été mise à jour avec succès.",
  "settings_notifications_bcc_emailbox": "Nous venons d'envoyer un message de vérification à <{email}>.",
  "settings_notifications_bcc_update_success": "La CCI {email} a été mise à jour avec succès.",
  "settings_notifications_smtp_auth_enabled": "Activé",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(le mot de passe que vous utilisez pour accéder à ce tableau de bord)",
  "settings_notifications_smtp_password": "Mot de passe SMTP",
  "settings_notifications_smtp_ports": "Ports SMTP",
  "settings_notifications_smtp_server": "Serveur SMTP",
  "settings_notifications_smtp_username": "Nom d'utilisateur SMTP",
  "settings_open_tracking": "Ouvrir le suivi",
  "settings_open_tracking_description": "L'activation du suivi ouvert créera un enregistrement de vos messages ouverts, vous permettant de mieux suivre les résultats de la campagne.",
  "settings_setting_changed": "Paramètre modifié {service}",
  "settings_setting_disabled": "Paramètre désactivé {service}",
  "settings_setting_enabled": "Paramètre activé {service}",
  "settings_setting_notdisabled": "Le paramètre {service} ne peut pas être activé.",
  "settings_setting_notenabled": "Le paramètre {service} ne peut pas être activé.",
  "settings_setting_webhook_notenabled": "Les Web-hooks de notification d'événement ne sont disponibles que sur les forfaits récurrents PRO.",
  "settings_smtp_description": "Pour vous connecter via SMTP, configurez le SMTP dans votre logiciel de messagerie ou dans toute autre application de messagerie en ajoutant les paramètres suivants. Cliquez sur le bouton « Plus » pour voir les paramètres.",
  "settings_smtp_slide_description": "Configurez SMTP dans votre logiciel de messagerie ou dans toute autre application de messagerie en ajoutant les paramètres suivants.",
  "settings_smtp_slide_description_api": "Le nom d'utilisateur et le mot de passe d'authentification SMTP constituent une paire de clés API : utilisez le Consumer Key comme nom d'utilisateur SMTP et le Consumer Secret comme mot de passe SMTP. Considérez-les comme des identifiants à garder secrets et à renouveler si nécessaire.",
  "settings_smtp_slide_parameter": "Paramètres",
  "settings_smtp_slide_title": "Connexion via SMTP",
  "settings_smtp_slide_value": "Valeur",
  "settings_smtp_title": "Connexion via SMTP",
  "settings_template_description": "Les modèles sont l'outil parfait pour donner facilement à votre e-mail une mise en page efficace.",
  "settings_template_slide_add": "Ajouter modèle",
  "settings_template_slide_default": "Par défaut",
  "settings_template_slide_description": "Cliquez sur « Ajouter modèle » et remplissez les champs avec les informations requises, y compris le nom du modèle et le code HTML ou texte brut.",
  "settings_template_slide_empty_description": "Cliquez sur « Ajouter modèle » et remplissez les champs avec les informations requises, y compris le nom du modèle et le code HTML ou texte brut.",
  "settings_template_slide_empty_title": "Ajouter un modèle",
  "settings_template_slide_html": "Version HTML",
  "settings_template_slide_info": "<% body %> est obligatoire dans le texte HTML et le texte brut. L'espace réservé sera remplacé par du contenu réel.",
  "settings_template_slide_name": "Nom du modèle",
  "settings_template_slide_plaintext": "Version texte brut",
  "settings_template_slide_title": "Modèles",
  "settings_template_title": "Modèles",
  "settings_title": "Réglages",
  "settings_tracking": "Suivi",
  "settings_unsubscribe_description": "Ajoutez un lien de désinscription au bas des e-mails textuels et HTML. Aucun e-mail ne sera transféré aux utilisateurs désinscrits.",
  "settings_unsubscribe_select": "Sélectionner une langue",
  "settings_unsubscribe_slide_add": "Ajouter un lien de désinscription",
  "settings_unsubscribe_slide_description": "Ajoutez un lien de désinscription au bas des e-mails textuels et HTML. Aucun e-mail ne sera transféré aux utilisateurs désinscrits. Les annulations d'inscription seront gérées automatiquement et en temps réel pour améliorer votre réputation de publipostage. Entrez le texte que vous souhaitez utiliser (par exemple « Pour vous désinscrire, cliquez ici») puis collez le texte dans l'espace réservé de votre message.",
  "settings_unsubscribe_slide_empty": "Ajouter un lien de désinscription",
  "settings_unsubscribe_slide_empty_description": "Ajoutez un lien de désinscription au bas des e-mails textuels et HTML. Aucun e-mail ne sera transféré aux utilisateurs désinscrits. Les annulations d'inscription seront gérées automatiquement et en temps réel pour améliorer votre réputation depublipostage.",
  "settings_unsubscribe_slide_language": "Sélectionner une langue",
  "settings_unsubscribe_slide_placeholder": "Espace réservé",
  "settings_unsubscribe_slide_text": "Texte de désinscription",
  "settings_unsubscribe_slide_title": "Lien de désinscription",
  "settings_unsubscribe_text": "Texte",
  "settings_unsubscribe_title": "Lien de désinscription",
  "settings_unsubscribe_value": "Ex. Pour se désinscrire, cliquez ici",
  "settings_webhooks_description": "Les webhooks permettent à votre application Web de recevoir une notification des événements de transfert et d'interaction des e-mails.",
  "settings_webhooks_slide_alert": "Toute modification appliquée peut prendre jusqu'à 1 heure pour prendre effet.",
  "settings_webhooks_slide_bounced": "Rejeté",
  "settings_webhooks_slide_click": "Cliquer",
  "settings_webhooks_slide_deferred": "Différée",
  "settings_webhooks_slide_delivered": "Transféré",
  "settings_webhooks_slide_deliveryevents": "Événements de transfert",
  "settings_webhooks_slide_description": "Vous pouvez utiliser les Webhooks de notification d'événements pour être informé des événements qui se produisent dans votre projet de messagerie sans utiliser d'API.",
  "settings_webhooks_slide_dropped": "Abandonné",
  "settings_webhooks_slide_engagementevents": "Événements d'engagement",
  "settings_webhooks_slide_inserturl": "Insérez ici l'url que vous souhaitez voir notifiée",
  "settings_webhooks_slide_notification": "Url de notification Webhook",
  "settings_webhooks_slide_notification_description": "Activer les notifications de web-hook",
  "settings_webhooks_slide_open": "Ouvrir",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "Traité",
  "settings_webhooks_slide_spamreport": "Rapport de spam",
  "settings_webhooks_slide_title": "Webhooks",
  "settings_webhooks_slide_unsubscribe": "Se désinscrire",
  "settings_webhooks_support": "Veuillez contacter l'assistance et demander « l'activation des événements de transfert ».",
  "settings_webhooks_title": "Webhooks",
  "settings_webhooks_upgrade": "Débloquer forfait PRO",
  "subaccount_policy_agree": "J'ai lu et j'accepte les <a href=\"https://serversmtp.com/fr/fr_terms-and-conditions/\" target=\"_blank\">conditions d'utilisation</a> et <a href=\"https://serversmtp.com/fr/politique-de-confidentialite-reglement-ue-2016-79-rgdp/\" target=\"_blank\">la politique de confidentialité</a>",
  "subaccount_policy_agree_notchecked": "Vous devez accepter les Conditions d'utilisation et la Politique de confidentialité",
  "subaccount_slide_inuse": "En cours d'utilisation",
  "subaccount_slide_ip": "adresse IP",
  "subaccount_slide_ips": "adresse IP",
  "subaccount_slide_ips_description": "Veuillez sélectionner une adresse IP à attribuer à ce sous-compte.",
  "subaccounts_action_activated": "{email} a été activé avec succès",
  "subaccounts_action_active": "Actif",
  "subaccounts_action_deactivated": "{email} a été suspendu avec succès",
  "subaccounts_action_delete": "Supprimer",
  "subaccounts_action_deleted": "Sous-compte supprimé avec succès",
  "subaccounts_action_details": "Détails",
  "subaccounts_action_edit": "Éditer",
  "subaccounts_action_limit": "Établir limites",
  "subaccounts_action_login": "Connexion",
  "subaccounts_action_notdeleted": "Erreur lors de la suppression du sous-compte",
  "subaccounts_action_suspend": "Suspendre",
  "subaccounts_active": "Actif",
  "subaccounts_added_succesfully": "Le sous-compte a été ajouté avec succès",
  "subaccounts_agencysettings": "Réglages agence",
  "subaccounts_assigned_ip": "IP attribuée",
  "subaccounts_changed_succesfully": "Le sous-compte a été modifié avec succès",
  "subaccounts_confirm_activation_label": "Confirmer activation",
  "subaccounts_confirm_activation_text": "Voulez-vous activer {email} ?",
  "subaccounts_confirm_deactivation_label": "Confirmer la désactivation",
  "subaccounts_confirm_deactivation_text": "Voulez-vous suspendre le sous-compte : {email} ?",
  "subaccounts_confirm_delete_label": "Confirmer la suppression",
  "subaccounts_confirm_delete_text": "Voulez-vous supprimer le sous-compte {email} ?",
  "subaccounts_confirm_login_label": "Confirmer la connexion",
  "subaccounts_confirm_login_text": "Voulez-vous vraiment vous déconnecter du compte actuel et vous connecter à {email} ?",
  "subaccounts_confirmation": "Confirmation",
  "subaccounts_create_warning": "La création de nouveaux sous-comptes n'est disponible qu'avec les abonnements professionnels.",
  "subaccounts_email": "E-mail du compte",
  "subaccounts_empty": "Développez votre activité et offrez à vos clients un service professionnel entièrement personnalisable avec votre marque, ou répartissez vos e-mails entre vos employés et collègues.<br>Une interface de gestion simple vous permettra de suivre le trafic et les statistiques.",
  "subaccounts_expiration_date": "Date d’expiration",
  "subaccounts_inactive": "Inactif",
  "subaccounts_ip": "adresse IP",
  "subaccounts_last_activity": "Dernière activité",
  "subaccounts_limits_nolimits": "Aucune limite",
  "subaccounts_limits_sending": "Limite d'envoi :",
  "subaccounts_limits_slide_description": "Définissez une limite pour votre sous-compte.",
  "subaccounts_limits_slide_limits": "Limites",
  "subaccounts_limits_slide_noplan_expiration": "Aucune expiration",
  "subaccounts_limits_slide_plan_expiration": "Expiration du forfait",
  "subaccounts_limits_slide_set_plan_expiration": "Définir l'expiration du forfait",
  "subaccounts_limits_slide_this_number": "Ce chiffre correspond à une période",
  "subaccounts_limits_slide_title": "Limites des sous-comptes",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "D'après l'expiration du forfait du compte principal",
  "subaccounts_settings_update": "Les réglages du sous-compte sont à présent à jour.",
  "subaccounts_slide_account_confirm": "Confirmez les informations du compte",
  "subaccounts_slide_account_description": "Cliquez sur le bouton Éditer pour modifier les informations d'utilisateur de votre sous-compte.",
  "subaccounts_slide_account_info": "Informations du compte",
  "subaccounts_slide_address": "Adresse",
  "subaccounts_slide_address2": "Adresse 2",
  "subaccounts_slide_change_password": "Définir un mot de passe",
  "subaccounts_slide_city": "Ville",
  "subaccounts_slide_company": "Nom de l’entreprise",
  "subaccounts_slide_confirm_password": "Confirmer mot de passe",
  "subaccounts_slide_confirmpassword_different": "Assurez-vous que vos deux mots de passe soient identiques.",
  "subaccounts_slide_country": "Pays",
  "subaccounts_slide_email": "Adresse e-mail",
  "subaccounts_slide_email_not_unique": "Cette adresse e-mail est déjà utilisée.",
  "subaccounts_slide_email_required": "Une adresse e-mail est requise.",
  "subaccounts_slide_first_name": "Prénom",
  "subaccounts_slide_firstname_required": "Le prénom est requis.",
  "subaccounts_slide_last_name": "Nom",
  "subaccounts_slide_lastname_required": "Le nom est requis.",
  "subaccounts_slide_password": "Mot de passe",
  "subaccounts_slide_password_details": "Laissez le champ du mot de passe vide pour continuer à utiliser votre mot de passe actuel.",
  "subaccounts_slide_password_minlength": "La longueur du mot de passe doit être d'au moins {req}. Il est actuellement : {act}.",
  "subaccounts_slide_password_required": "Le mot de passe est requis.",
  "subaccounts_slide_password_pattern": "Le mot de passe doit contenir au moins 10 caractères, dont au moins un majuscule, un minuscule et un chiffre",
  "subaccounts_slide_phone": "Téléphone",
  "subaccounts_slide_profile_information": "Informations de profil",
  "subaccounts_slide_region": "Région/Département/Commune",
  "subaccounts_slide_website": "Site Web",
  "subaccounts_slide_zip": "Code postal",
  "subaccounts_status": "État",
  "subaccounts_subaccounts": "Liste des sous-comptes",
  "subaccounts_title": "Sous-comptes",
  "subaccounts_unlimited": "Illimité <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "D'après la limite du forfait du compte principal.",
  "subaccounts_usage": "Utilisation",
  "sunday": "Dimanche",
  "suppression_deleted": "Les suppressions seront effacées sous peu.",
  "suppression_filters_reason": "Motif",
  "suppression_filters_recipient": "Destinataire",
  "suppression_filters_sender": "Émetteur",
  "suppression_filters_sources": "Sources",
  "suppression_filters_subject": "Objet de l'e-mail",
  "suppression_operators_exclude": "Exclure",
  "suppression_operators_include": "Inclure",
  "suppression_table_addcolumn_sender": "Émetteur",
  "suppression_table_dropdown_text": "{first} — {last} sur {totalRecords}",
  "suppression_types_bounce": "Rejeté",
  "suppression_types_manual": "Manuel",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Désinscrit",
  "suppression_types_validation_failed": "Échec de la validation",
  "suppressions_add_form_errors": "Erreurs formulaire",
  "suppressions_add_form_nofile_selected": "Aucun fichier n’a été sélectionné",
  "suppressions_add_suppression": "Suppressions d'importation",
  "suppressions_choose_columns": "Choisissez les colonnes",
  "suppressions_confirm_delete_all_label": "Confirmer action",
  "suppressions_confirm_delete_all_text": "Voulez-vous vraiment supprimer toutes les suppressions entre <strong>{from}</strong> et <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "Voulez-vous vraiment effacer<br> toutes les suppressions <strong>{type}</strong> entre <strong>{from}</strong> et <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Confirmer action",
  "suppressions_confirm_delete_filtered_text": "Voulez-vous vraiment effacer toutes les <strong>suppressions filtrées</strong>? <br><small>*Les entrées de spam ne seront pas effacées.</small>",
  "suppressions_confirm_delete_selected_label": "Confirmer action",
  "suppressions_confirm_delete_selected_text": "Voulez-vous vraiment effacer les suppressions sélectionnées ?",
  "suppressions_date": "Date",
  "suppressions_delete_all": "Effacer tout",
  "suppressions_delete_selected": "Effacer la sélection",
  "suppressions_deleted": "Les suppressions seront effacées sous peu.",
  "suppressions_description_empty": "Aucune entrée n'a été trouvée pour la période sélectionnée.",
  "suppressions_details_date": "Date",
  "suppressions_details_entry": "Entrée",
  "suppressions_details_reason": "Motif",
  "suppressions_details_sender": "Émetteur",
  "suppressions_details_subject": "Sujet",
  "suppressions_details_title": "Détails",
  "suppressions_details_type": "Type",
  "suppressions_imported": "Vos suppressions seront bientôt importées.",
  "suppressions_imported_partial": "{imported} / {total} suppressions seront bientôt importées.",
  "suppressions_include": "Inclure",
  "suppressions_modal_confirm": "Confirmation",
  "suppressions_not_imported": "Les suppressions ne seront pas importées en raison d'e-mails malformés.",
  "suppressions_reason": "Motif",
  "suppressions_recipient": "Destinataire",
  "suppressions_title": "Suppressions",
  "suppressions_title_empty": "Aucune suppression trouvée",
  "suppressions_type": "Type",
  "t_api": "Documentation de l’API",
  "t_knowledgebase": "Base de connaissance",
  "t_logout": "Déconnexion",
  "table_dropdown_goto": "Accéder à la page",
  "table_dropdown_text": "{first} — {last} sur {totalRecords}",
  "thursday": "Jeudi",
  "toggle_off": "Désactivé",
  "toggle_on": "Activé",
  "token_can_not_be_empty": "Le jeton ne peut pas être vide.",
  "token_is_missing": "Le jeton est manquant.",
  "tuesday": "Mardi",
  "unlimited": "illimité",
  "upload_add_manually": "Ajouter manuellement",
  "upload_add_manually_description": "Copiez et collez plusieurs adresses e-mail ou en masse dans la zone ci-dessous, séparées par une ligne de fin. Pour vous souvenir de la raison pour laquelle vous avez ajouté les contacts et faciliter les recherches futures, ajoutez un motif de suppression de ces adresses.",
  "upload_add_manually_placheholder": "e-mail1, e-mail2, e-mail3, e-mail4, e-mail5...",
  "upload_add_reason": "Entrez une raison pour supprimer ces adresses.",
  "upload_allowed_files": "Les formats de fichiers autorisés sont csv ou txt.",
  "upload_dd_here": "Glissez et déposez votre fichier ici",
  "upload_import_from_file": "Importer à partir d'un fichier",
  "upload_import_from_file_description": "Le fichier doit être une colonne contenant toutes les adresses e-mail que vous souhaitez importer. Pour vous souvenir de la raison pour laquelle vous avez ajouté les contacts et faciliter les recherches futures, ajoutez un motif de suppression de ces adresses.",
  "warning_lang": "Le tableau de bord dans votre langue sera bientôt disponible. En attendant, contactez l'équipe d'assistance pour revenir à l'ancien.",
  "wednesday": "Mercredi",
  "whitelabel_agencyname": "Nom de l'agence",
  "whitelabel_companydetails": "Coordonnées de l'entreprise",
  "whitelabel_description": "Si vous avez ouvert un sous-compte et que vous êtes un revendeur officiel de turboSMTP, la personnalisation du produit avec votre logo et les informations de votre entreprise permettra aux clients de vivre l'expérience de votre marque.",
  "whitelabel_footer": "Pied de page de l'agence",
  "whitelabel_footer_description": "Insérez le code HTML à afficher en pied de page.",
  "whitelabel_logo": "Logo de l'entreprise",
  "whitelabel_logo_description": "Taille d’Image maximale autorisée : 472x72px",
  "whitelabel_reset_default_image": "Restaurer l'image par défaut",
  "whitelabel_upload_image": "Charger l'image",
  "whitelabel_upload_in_progress": "Chargement en cours",
  "whitelabel_website": "Site de l'agence",
  "wrong_credentials_specified": "Les identifiants spécifiés sont erronés.",
  "yes": "Oui",
  "missing_required_parameter_amount": "Veuillez insérer le montant",
  "amount_should_be_integer": "Le montant doit être un numéro entier",
  "amount_should_not_be_less_than_15": "Le montant ne doit pas être inférieur à 15",
  "amount_should_not_be_higher_than_1800": "Le montant ne doit pas dépasser 1800",
  "missing_settings_required": "Certaines paramètres sont nécessaires pour activer cette option",
  "settings_apikeys_title": "Clés API",
  "settings_apikeys_description": "Les Clés API constituent un moyen hautement sécurisé de connecter les services turboSMTP à vos applications. Vous pouvez révoquer l'accès à tout moment.",
  "settings_apikeys_slide_title": "Clés API",
  "settings_apikeys_slide_description": "Gérez vos Clés API. Ce tableau montre toutes vos Clés API actives. Vous pouvez créer de nouvelles clés ou supprimer des clés existantes pour révoquer l'accès.",
  "settings_apikeys_slide_empty_title": "Créer une Clé API",
  "settings_apikeys_slide_empty_description": "Les Clés API sont composées d’un Consumer Key et d’un Consumer Secret. Ce sont des informations d'identification logicielles qui permettent à un programme d'accéder à votre compte turboSMTP sans utiliser votre nom d'utilisateur et votre mot de passe. Ils sont hautement sécurisés et peuvent être révoqués à tout moment sans modifier les informations d'accès au panneau turboSMTP.",
  "settings_apikeys_slide_add": "Créer une Clé API",
  "settings_apikeys_slide_add_description": "Choisissez un nom de référence pour votre Clé API.",
  "settings_apikeys_apikey_name": "Nom",
  "settings_apikeys_slide_label_info": "Ce nom est uniquement à titre de référence. Vous n’aurez pas besoin de saisir le nom dans vos applications.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Date de creation",
  "settings_apikeys_apikey_name_label": "Nom de la Clé API",
  "settings_apikeys_apikey_name_placeholder": "Entrez le nom de votre Clé API",
  "settings_apikeys_apikey_revoke_alt": "Supprimer et révoquer",
  "settings_apikeys_apikey_confirm_revoke_label": "Supprimer et révoquer la Clé API",
  "settings_apikeys_apikey_confirm_revoke_text": "Supprimer la Clé API \"{name}\" ?<br>Cela révoquera l'accès à toutes les applications qui utilisent cette clé.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Confirmer",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Annuler",
  "settings_apikeys_apikey_revoked": "Clé API révoquée avec succès",
  "settings_apikeys_apikey_consumerkey_button_add": "Générer une Clé API",
  "settings_apikeys_apikey_new_success": "Clé API créée !",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "Ce <strong>Consumer Secret</strong> n'est affiché qu'ici. <strong>Copiez-le maintenant et enregistrez-le dans un endroit sûr</strong>. Si vous perdez cette clé, vous devrez la supprimer et en générer une nouvelle.",
  "settings_apikeys_restrict_ip_label": "Restreindre la clé API à des IP spécifiques",
  "settings_apikeys_restrict_ip_description": "Lorsque cette option est activée, cette clé API ne fonctionnera qu'à partir des adresses IP spécifiées.",
  "settings_apikeys_allowed_ips_label": "Adresses IP autorisées",
  "settings_apikeys_ip_placeholder": "Entrez l'adresse IP (ex. 8.8.8.8)",
  "settings_apikeys_add_ip": "Ajouter une adresse IP",
  "settings_apikeys_remove_ip": "Supprimer l'adresse IP",
  "settings_apikeys_ip_required": "L'adresse IP est requise",
  "settings_apikeys_ip_invalid": "Veuillez entrer une adresse IP valide",
  "settings_apikeys_allowed_ips": "IPs autorisées:",
  "settings_apikeys_ips_label": "Restriction d'IP",
  "settings_apikeys_permissions_label": "Permissions API",
  "settings_apikeys_permissions_description": "Choisissez les services auxquels cette clé API peut accéder.",
  "settings_apikeys_permission_send_smtp": "Envoi SMTP",
  "settings_apikeys_permission_send_api": "Envoi HTTP API",
  "settings_apikeys_permission_apis": "Statistiques et APIs de gestion",
  "settings_apikeys_permissions_required": "Veuillez sélectionner au moins une option",
  "settings_apikeys_legacy_key_alert_message": "Nous avons mis à jour notre <strong>authentification SMTP</strong> pour utiliser des <strong>clés API</strong> au lieu de votre mot de passe de compte.<br>Pour assurer une transition en douceur, <strong>nous avons créé une clé API spéciale</strong> pour vous qui correspond à vos anciennes informations d'identification. Pour une sécurité améliorée, nous vous recommandons fortement de <strong>supprimer cette clé et d'en créer une nouvelle</strong> à utiliser dans vos paramètres SMTP.",
  "settings_apikeys_legacy_key_alert_link": "Plus d'infos",
  "settings_apikeys_legacy_key_alert_link_href": "https://serversmtp.com/fr/mise-a-jour-de-securite-passage-a-lauthentification-par-cles-api/",
  "settings_apikeys_apikey_edit_alt": "Modifier la clé API",
  "settings_apikeys_slide_edit_description": "Modifiez les détails de la clé API ci-dessous.",
  "settings_apikeys_apikey_updated": "Clé API mise à jour avec succès",
  "settings_apikeys_apikey_consumerkey_button_save": "Enregistrer les modifications",
  "settings_bccs_missing_required": "Assurez-vous de définir un BCC par défaut avant d'activer cette option",
  "settings_bccs_notifications_default": "Email BCC par défaut mis à jour avec succès",
  "settings_link_branding_enable": "Activez pour utiliser votre propre domaine de suivi",
  "settings_link_branding_missing_required": "Ajoutez et vérifiez au moins un domaine avant de l'activer",
  "settings_link_branding_title": "Domaines de Suivi Personnalisés",
  "settings_link_branding_description": "Utilisez vos propres domaines pour le suivi des ouvertures et des clics au lieu de ceux inclus par turboSMTP",
  "settings_link_branding_box_alert": "Ces paramètres n’auront aucun effet si le suivi des ouvertures et le suivi des clics sont désactivés.",
  "settings_link_branding_empty_description": "Cliquez sur \"Ajouter un domaine\" et remplissez les champs demandés...",
  "settings_link_branding_empty_title": "Ajouter un Domaine de Suivi",
  "settings_link_branding_add_domain": "Ajouter un Domaine de Suivi",
  "settings_link_branding_add_domain_info": "Entrez votre domaine et modifiez quelques paramètres supplémentaires.",
  "settings_link_branding_advanced": "Options avancées",
  "settings_link_branding_custom_subdomain": "Sous-domaine personnalisé",
  "settings_link_branding_custom_subdomain_tooltip": "Veuillez ajouter un nom de domaine valide avant de spécifier un sous-domaine personnalisé",
  "settings_link_branding_custom_subdomain_info": "Le système générera un sous-domaine aléatoire. Si vous souhaitez en utiliser un spécifique, saisissez-le ici.",
  "settings_link_branding_button_add": "Ajouter un Domaine de Suivi",
  "settings_link_branding_match": "Faites correspondre le domaine de suivi au domaine de l'expéditeur",
  "settings_link_branding_match_sender_disabled": "Domaines correspondants désactivés",
  "settings_link_branding_match_sender_enabled": "Domaines correspondants activés",
  "settings_link_branding_filters_no_results": "Aucune entrée n'a été trouvée avec ces filtres.",
  "settings_link_branding_search_placeholder": "Filtrer les domaines de suivi par nom...",
  "settings_link_branding_verification_placeholder": "Validation,..",
  "settings_link_branding_verified": "Vérifié",
  "settings_link_branding_click_to_verify": "EN ATTENTE: La configuration CNAME pour ce domaine n'a pas été terminée ou vérifiée. Cliquez pour continuer...",
  "settings_link_branding_verification_success": "Vérification réussie",
  "settings_link_branding_verification_domain_not_found": "Domaine introuvable",
  "settings_link_branding_verification_cname_not_found": "CNAME pour le sous-domaine {track_dns} introuvable",
  "settings_link_branding_verification_auth_cname_not_found": "CNAME pour le sous-domaine {auth_dns} introuvable",
  "settings_link_branding_verification_multiple_cname_found": "Plusieurs enregistrements CNAME trouvés pour le sous-domaine {track_dns}",
  "settings_link_branding_verification_auth_multiple_cname_found": "Plusieurs enregistrements CNAME trouvés pour le sous-domaine {auth_dns}",
  "settings_link_branding_verification_incorrect_cname_target": "Le CNAME du sous-domaine {track_dns} a une valeur incorrecte",
  "settings_link_branding_verification_auth_incorrect_cname_target": "Le CNAME du sous-domaine {auth_dns} a une valeur incorrecte",
  "settings_link_branding_enabled": "Activé",
  "settings_link_branding_disabled": "Désactivé",
  "settings_link_branding_not_verified": "En Attente",
  "settings_link_branding_name": "Nom de domaine",
  "settings_link_branding_enabled_no": "Domaine de suivi désactivé",
  "settings_link_branding_enabled_yes": "Domaine de suivi activé",
  "settings_link_branding_default_enabled": "Domaine de suivi défini comme Non dédié",
  "settings_link_branding_default_disabled": "Domaine de suivi défini comme Dédié",
  "settings_link_branding_subdomain_name_invalid": "Le sous-domaine n'est pas valide",
  "settings_link_branding_domain_name_invalid": "Nom de domaine invalide",
  "settings_link_branding_confirm_delete_label": "Supprimer le domaine de suivi",
  "settings_link_branding_confirm_delete_text": "Voulez-vous vraiment supprimer ce domaine de suivi ?",
  "invalid_domain_name": "Nom de domaine invalide",
  "settings_link_branding_exclusivity_placeholder": "Il est dédié...",
  "settings_link_branding_exclusive": "Dédié",
  "settings_link_branding_not_exclusive": "Non dédié",
  "settings_link_branding_domain_name": "Domaine de Suivi",
  "settings_link_branding_domain_status": "État",
  "settings_link_branding_added": "Domaine ajouté avec succès",
  "settings_link_branding_removed": "Domaine supprimé avec succès",
  "settings_link_branding_default_match_help": "Les domaines dédiés ne sont utilisés qu'avec les domaines d'expéditeur correspondants. Ils ne sont jamais utilisés avec des domaines d'expéditeur différents.",
  "settings_link_branding_dns_info": "Vous devrez ajouter les enregistrements suivants pour terminer la configuration.",
  "settings_link_branding_ssl_verify": "Nous ne pouvons pas vérifier si vos domaines SSL sont correctement configurés depuis le tableau de bord. Si vous avez besoin d'aide, veuillez contacter notre équipe de support technique.",
  "settings_link_branding_dns_wait": "Les modifications apportées aux enregistrements DNS peuvent prendre jusqu'à 24 heures pour prendre effet",
  "settings_link_branding_dns_info_host": "Veuillez ajouter ces deux enregistrements à la section DNS de votre hébergement.",
  "settings_link_branding_dns_type": "Type",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Certains hébergements DNS peuvent y faire référence sous le nom de  \"Domain\" or \"Name\"",
  "settings_link_branding_dns_value": "Valeur",
  "settings_link_branding_dns_value_help": "Certains hébergements DNS peuvent y faire référence sous le nom de \"Data\"",
  "settings_link_branding_dns_help": "Vous ne savez pas comment procéder ?",
  "settings_link_branding_dns_help_link": "Voir la documentation",
  "settings_link_branding_dns_verification_tooltip": "Cet enregistrement CNAME est le même pour tous les sous-domaines du domaine. Il ne doit être ajouté qu'une seule fois : s'il est déjà présent, il n'est pas nécessaire de l'ajouter.",
  "settings_link_branding_verify_description": "Une fois ajouté, appuyez sur Vérifier.",
  "settings_link_branding_verify_button": "Vérifier",
  "settings_link_branding_delete_info": "Vous n'avez plus besoin de ce domaine de suivi ?",
  "settings_link_branding_delete_button": "Supprimer le domaine de suivi",
  "settings_link_branding_security_placeholder": "Sécurité...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "État...",
  "settings_link_branding_status_enabled_no": "Désactivé",
  "settings_link_branding_status_enabled_yes": "Actif",
  "settings_link_branding_all_domains_disabled": "Si tous les domaines personnalisés sont désactivés ou en attente, les domaines de suivi turboSMTP seront utilisés.",
  "settings_link_branding_no_default_domain": "Si vous définissez tous les liens de suivi actifs sur dédiés, les expéditeurs dont les domaines sont désactivés ou manquants dans cette liste utiliseront nos liens de suivi turboSMTP.",
  "settings_link_branding_match_modal_cancel": "Annuler",
  "settings_link_branding_match_modal_confirm": "D'accord",
  "settings_link_branding_match_title": "Rotation des Domaines",
  "settings_link_branding_match_change": "Changer ce comportement",
  "settings_link_branding_match_enabled_title": "Faire correspondre le domaine de l'expéditeur",
  "settings_link_branding_match_disabled_title": "Ne faire pas correspondre le domaine de l'expéditeur",
  "settings_link_branding_match_enabled_info": "Si le domaine de l'expéditeur correspond à l'un des domaines de suivi actifs, ce domaine de suivi sera utilisé.<br> Si le domaine de l'expéditeur ne correspond à aucun domaine de suivi, l'un des domaines de suivi actifs (à l'exception des \"Dédiés\" ) sera utilisé. au hasard.",
  "settings_link_branding_match_disabled_info": "Tous les domaines de suivi actifs seront utilisés, quel que soit le domaine de l'expéditeur.",
  "config_server_error": "Le tableau de bord est en cours de maintenance, veuillez réessayer dans quelques minutes",
  "feature_not_available_for_active_plan": "Cette fonctionnalité n'est incluse dans aucun de vos plans",
  "forgot_password_use_different_password": "Veuillez créer un nouveau mot de passe différent de vos mots de passe précédents pour renforcer la sécurité de votre compte.",
  "m_getting_started": "Accueil",
  "settings_sender_title": "Vérification des Domaines d'Expéditeur",
  "settings_sender_add_domain": "Ajouter un Domaine",
  "settings_sender_description": "Pour améliorer la délivrabilité de vos emails, il vous suffit d'authentifier vos domaines d'expéditeur avec trois enregistrements DNS essentiels.",
  "settings_sender_domains_empty": "Vous n'avez pas encore de domaines d'expéditeur vérifiés.<br>Veuillez vérifier votre premier domaine.",
  "settings_sender_if_unverified": "Que se passe-t-il si le domaine de l'expéditeur n'est pas vérifié ?",
  "settings_sender_notify_label": "Me notifier par email si le domaine de l'expéditeur n'est pas vérifié",
  "settings_sender_notify_email_label": "Email",
  "settings_sender_notify_email_tip": "Si le champ est vide, la notification sera envoyée à l'adresse de votre compte turboSMTP.",
  "settings_sender_notify_email_error": "Veuillez entrer une adresse email valide",
  "settings_sender_notify_email_placeholder": "Saisissez une adresse email...",
  "settings_sender_dns_title": "Comment vérifier votre domaine",
  "settings_sender_dns_description": "Pour notre service SMTP, vous devez configurer les enregistrements SPF et DKIM sur vos domaines d'expéditeur. Ajouter un enregistrement DMARC est également obligatoire pour améliorer la sécurité et la délivrabilité de vos emails.",
  "settings_sender_spf_title": "Enregistrement SPF",
  "settings_sender_spf_description": "Veuillez procéder en ajoutant l'enregistrement TXT spécifié au domaine de l'expéditeur, en choisissant l'une des deux alternatives suivantes :",
  "settings_sender_dkim_title": "Enregistrement DKIM",
  "settings_sender_dkim_description": "Pour le DKIM, ajoutez l'enregistrement TXT fourni à la configuration DNS de votre domaine, qui contient la clé publique utilisée pour vérifier que les emails envoyés depuis votre domaine sont légitimes et n'ont pas été altérés pendant le transit.",
  "settings_sender_dmarc_title": "Enregistrement DMARC",
  "settings_sender_dmarc_description": "Complétez le processus d'authentification de vos emails en ajoutant l'enregistrement DMARC TXT à votre DNS, en définissant une politique sur la manière dont les destinataires de courrier doivent traiter les messages qui ne passent pas les vérifications SPF ou DKIM, offrant ainsi une couche de défense supplémentaire contre les pratiques frauduleuses par email.",
  "settings_sender_domain_added": "Domaine d'expéditeur <strong>{domain}</strong> ajouté.",
  "settings_sender_domain": "Domaine d'expéditeur",
  "settings_sender_domains_name": "Nom du domaine",
  "settings_sender_domains_action_verify": "Vérifier",
  "settings_sender_domains_action_delete": "Supprimer",
  "settings_sender_domains_action_subaccount": "Sous-compte :",
  "settings_sender_action_delete_confirm_title": "Supprimer le domaine",
  "settings_sender_action_delete_confirm_message": "Êtes-vous sûr de vouloir supprimer le domaine <strong>{domainName}</strong> ?",
  "settings_sender_domain_description": "Veuillez spécifier le domaine d'expéditeur que vous souhaitez valider :",
  "settings_sender_verify_record": "Enregistrement TXT",
  "settings_sender_verify_value": "État",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Veuillez contacter votre administrateur de compte pour vérifier le domaine. Cette action est requise et ne peut être effectuée que par le titulaire principal du compte.",
  "settings_sender_verify_fail": "{type} non trouvé ou mal configuré",
  "settings_sender_verified": "Votre domaine est correctement configuré. Vous pouvez envoyer en toute sécurité en utilisant cet expéditeur.",
  "settings_sender_dkim_domain_title": "Domaine DKIM",
  "settings_sender_dkim_value_title": "Valeur DKIM",
  "settings_sender_dmarc_domain_title": "Domaine DMARC",
  "settings_sender_dmarc_value_title": "Valeur DMARC",
  "settings_sender_domains_search_placeholder": "Filtrer les domaines d'expéditeur par nom...",
  "settings_sender_domains_status_placeholder": "Vérification...",
  "settings_sender_domains_status_verified": "Vérifié",
  "settings_sender_domains_status_not_verified": "Non vérifié",
  "settings_sender_domains_filters_no_results": "Aucun résultat trouvé avec ces filtres",
  "block_unverified_sender_title": "Bloquer les domaines d'expéditeur non vérifiés",
  "block_unverified_sender_modal_title": "Domaines d'expéditeur non vérifiés",
  "block_unverified_sender_desc": "Si le domaine d'expéditeur n'est pas vérifié, bloquer l'envoi d'emails et me notifier par email",
  "block_unverified_sender_change": "Changer ce comportement",
  "forward_as_received_title": "Envoyer Sans Modifications",
  "forward_as_received_info": "Envoyez vos emails sans modifications, même depuis des domaines d'expéditeur non vérifiés. Notez que cela entraînera probablement un <strong>taux de rebond élevé et une faible délivrabilité</strong>, car vos emails risquent d'être marqués comme spam, affectant la réputation de votre domaine.",
  "block_title": "Rejeter et Supprimer",
  "block_info": "Choisissez cette option pour vous assurer qu'aucun email ne soit envoyé depuis des domaines d'expéditeur non vérifiés. Les messages qui ne passent pas les vérifications SPF, DKIM ou DMARC seront automatiquement supprimés pour <strong>maintenir votre réputation d'expéditeur</strong> et prévenir le risque d'être marqué comme spam.",
  "fallback_to_turbo_title": "Ré-enveloppement de l'Expéditeur",
  "fallback_to_turbo_info": "Optez pour un ré-enveloppement en utilisant une adresse turboSMTP comme expéditeur pour les emails provenant de domaines d'expéditeur non vérifiés. Cela peut améliorer la délivrabilité, bien que le <strong>changement d'adresse d'expéditeur puisse être remarqué</strong> par les destinataires dans leurs clients de messagerie.",
  "notification_email_updated": "Email de notification mis à jour.",
  "notification_email_enabled": "Email de notification activé.",
  "notification_email_disabled": "Email de notification désactivé.",
  "invalid_notification_email": "Email de notification non valide",
  "settings_sender_domains_new_intro": "Entrez les informations du nouveau domaine",
  "paginator_page": "Page",
  "paginator_of": "sur",
  "no_records_found": "Enregistrement DNS non trouvé. Assurez-vous que l'enregistrement est correctement publié et que la propagation est terminée.",
  "invalid_record_found": "Un enregistrement DNS a été trouvé mais semble être mal formaté ou avoir une valeur non valide.",
  "too_many_dns_lookups": "L'enregistrement SPF comprend plus de 10 recherches DNS autorisées, ce qui peut causer des problèmes de livraison de courriels.",
  "more_than_spf_entry_found": "Plusieurs enregistrements SPF ont été détectés pour votre domaine. Un seul enregistrement SPF est permis par domaine.",
  "settings_sender_loading_domain_data": "Chargement des résultats de vérification de domaine...",
  "notice": "Avertissement",
  "settings_sender_domains_no_option": "<p>Votre compte fonctionne actuellement sous le \"Standard mode\", une <strong>configuration plus ancienne</strong> qui réemballe tous les e-mails sortants avec notre adresse e-mail, indépendamment de vos paramètres SPF, DKIM et DMARC.</p>\n<p>Pour améliorer la délivrabilité des e-mails, nous recommandons fortement de choisir l'une des options de secours mises à jour disponibles.</p>",
  "failed_to_get_a_aaaa_record": "Échec de l'obtention des enregistrements A / AAAA pour {domain_name}",
  "invalid_spf_syntax": "Syntaxe SPF invalide",
  "spf_has_upper_case_letters": "L'enregistrement SPF ne doit pas contenir de lettres majuscules. Veuillez vous assurer que tous les caractères sont en minuscules pour respecter les spécifications SPF.",
  "recursive_include_detected": "Votre enregistrement SPF ne doit pas inclure le domaine lui-même car cela crée une boucle entraînant des recherches DNS infinies. Veuillez réviser l'entrée SPF pour retirer la référence au domaine afin d'éviter les dépendances circulaires et de se conformer aux spécifications SPF.",
  "spf_longer_than_255_characters": "L'enregistrement SPF dépasse la limite de 255 caractères pour une chaîne de texte DNS unique. Afin de respecter les spécifications DNS, veuillez diviser votre enregistrement SPF en plusieurs chaînes, chacune ne dépassant pas 255 caractères, ou raccourcir l'enregistrement pour être conforme à la limite.",
  "ptr_mechanism_not_allowed": "Pour optimiser les performances de SPF et promouvoir l'adoption de pratiques de vérification d'expéditeur robustes, il est conseillé d'exclure le mécanisme ptr et de s'appuyer plutôt sur des mécanismes tels que ip4 et include.",
  "data_location_modal_title": "Localisation des données",
  "data_location_network_servers": "Serveurs réseau",
  "data_location_ip_location": "Localisation IP",
  "data_location_company_managing_data": "Société gestionnaire des données",
  "data_location_network_servers_value": "Milan (IT), Francfort (DE), Amsterdam (NL)",
  "data_location_ip_location_value": "Europe RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Italie UE",
  "data_location_no_transfer_outside_eu": "Aucune donnée n'est transférée hors de l'Union Européenne",
  "gdpr_data_location": "Données en UE",
  "gdpr_see_details": "Détails",
  "not_included_in_plan": "Non inclus dans votre plan actuel",
  "registration_logout": "Déconnexion",
  "registration_step_personal": "Infos Personnelles",
  "registration_step_company": "Infos Société",
  "registration_step_address": "Adresse",
  "registration_label_email": "Email",
  "registration_label_firstname": "Prénom",
  "registration_label_lastname": "Nom",
  "registration_label_company": "Société",
  "registration_label_vat": "Numéro de TVA",
  "registration_label_vat_optional": "(Optionnel)",
  "registration_label_phone": "Numéro de téléphone",
  "registration_label_website": "Site web",
  "registration_label_website_hint": "(Optionnel)",
  "registration_label_address": "Adresse",
  "registration_label_city": "Ville",
  "registration_label_country": "Pays",
  "registration_placeholder_country": "Sélectionner un pays",
  "registration_label_region": "État / Région",
  "registration_placeholder_region": "Sélectionner une région",
  "registration_label_zip": "Code Postal",
  "registration_btn_back": "Retour",
  "registration_btn_next": "Étape Suivante",
  "registration_btn_complete": "Compléter le Profil",
  "registration_error_firstname": "Le prénom est requis.",
  "registration_error_lastname": "Le nom est requis.",
  "registration_error_company": "La société est requise.",
  "registration_error_phone": "Le numéro de téléphone est requis.",
  "registration_error_website": "Veuillez entrer une URL valide.",
  "registration_error_address": "L'adresse est requise.",
  "registration_error_city": "La ville est requise.",
  "registration_error_country": "Le pays est requis.",
  "registration_error_region": "La région est requise.",
  "registration_error_zip": "Le code postal est requis.",
  "registration_error_phone_format": "Le numéro de téléphone ne doit contenir que des chiffres.",
  "registration_address_message": "En vous assurant que votre adresse postale est exacte, vous bénéficierez d'une <strong>expérience d'activation accélérée</strong>.",
  "registration_step_confirmation": "Confirmation",
  "registration_confirmation_title": "Profil complété !",
  "registration_confirmation_message": "Votre compte a été créé con succès.<br>Vous pouvez maintenant acheter un forfait pour débloquer des fonctionnalités avancées et des limites d'envoi plus élevées",
  "registration_confirmation_message_buy": "Votre compte a été créé con succès.",
  "registration_btn_buy_plan": "Acheter un forfait",
  "registration_stay_free": "Garder la version gratuite, vous pourrez mettre à niveau plus tard",
  "registration_btn_dashboard": "Aller au tableau de bord",
  "registration_redirect_to_shop": "Vous serez redirigé vers le processus de paiement dans un instant...",
  "registration_go_to_shop": "Cliquez ici pour procéder au paiement",
  "button_yes_delete": "Oui, supprimer",
  "button_yes_revoke": "Oui, révoquer"
}
